import { Disc3, RadioTower } from 'lucide-react';
import type { UpgradeProduct } from './upgradeOffers';

export interface SubscriptionOffer {
  id: 'creator-monthly' | 'all-access-yearly';
  product: UpgradeProduct;
  checkoutUrl?: string;
  checkoutImageUrl?: string;
  bestValue?: boolean;
}

/** Subscription plans shown only before an account has any confirmed purchase. */
export const SUBSCRIPTION_OFFERS: readonly SubscriptionOffer[] = [
  {
    id: 'creator-monthly',
    checkoutUrl: 'https://www.jvzoo.com/b/118831/455791/6',
    checkoutImageUrl: 'https://i.jvzoo.com/118831/455791/6',
    product: {
      name: 'Creator',
      tag: 'Monthly',
      price: 27,
      priceMeta: 'per month',
      billingNote: 'Billed monthly. Cancel anytime.',
      icon: Disc3,
      desc: 'Everything you need to create, shape and license your own songs.',
      features: [
        'All four creation routes — describe it, Music DNA, Genre Mixer, Image Music',
        'Lyrixsa Studio — extend, remix, replace sections, split stems, cover art',
        'Tempo and pitch adjustment, plus a full section-by-section lyrics editor',
        'Commercial license with a verifiable Certificate of Rights',
        'Library, playlists and the public Lyrixsa catalogue',
        'Downloads in supported audio formats',
      ],
    },
  },
  {
    id: 'all-access-yearly',
    bestValue: true,
    product: {
      name: 'All Access',
      tag: 'Yearly',
      price: 270,
      priceMeta: 'per year',
      priceSummary: 'Works out to $22.50 a month — you keep $54 a year',
      trial: {
        headline: '24 hours for $1',
        terms:
          'Your card is charged $1 today and the $1 is not refunded. Cancel within 24 hours and you are never charged the plan price.',
      },
      billingNote:
        'Your first $270 is charged 24 hours after you start, then yearly until you cancel.',
      icon: RadioTower,
      desc: 'Everything Lyrixsa does — create it, shape it, license it, and put it on the stores.',
      features: [
        'All four creation routes — describe it, Music DNA, Genre Mixer, Image Music',
        'Lyrixsa Studio — extend, remix, replace sections, split stems, cover art',
        'Tempo and pitch adjustment, plus a full section-by-section lyrics editor',
        'Commercial license with a verifiable Certificate of Rights',
        'Lyrixsa Publisher — assemble a release and send it to the stores',
        'Distribution to Spotify, Apple Music, YouTube Music, Amazon Music, TIDAL and more',
        'Publisher dashboard — per-store streams, payout states, listener geography',
        'Royalty payout reporting on your published releases',
        'Library, playlists and the public Lyrixsa catalogue',
      ],
    },
  },
] as const;
